module.exports = __webpack_public_path__ + "app-static/img/icon_wx_grey.d1ab8530.png";